import { useFormikContext } from "formik";
import { useEffect } from "react";

/*
  Gets the formik context of parent form
    Allows use of useEffect hook to give the form's parent access to properties
    of the form, such as:
      new changes to form values or whether the form is 'dirty' or not.
*/

const FormikContext = ({
  setValues,
  setEdited,
}: {
  setValues: Function;
  setEdited?: Function;
}) => {
  const { dirty, values } = useFormikContext();
  useEffect(() => {
    setEdited && setEdited(dirty);
    setValues(values);
  }, [values, dirty]);
  return null;
};

export default FormikContext;
